<template>
  <div v-if="loading || visibleTags.length" class="content-tag-filter">
    <span class="filter-label">标签</span>
    <button
      v-for="tag in visibleTags"
      :key="tag.tagId"
      type="button"
      class="tag-chip"
      :class="{ active: Number(modelValue) === Number(tag.tagId) }"
      :style="chipStyle(tag)"
      @click="toggle(tag.tagId)"
    >
      {{ tag.name }}
    </button>
    <button
      v-if="!showAll && extraCount > 0"
      type="button"
      class="tag-chip more"
      @click="showAll = true"
    >
      全部标签
    </button>
    <button
      v-else-if="showAll && recommended.length"
      type="button"
      class="tag-chip more"
      @click="showAll = false"
    >
      收起
    </button>
    <button
      v-if="modelValue"
      type="button"
      class="tag-chip clear"
      @click="$emit('update:modelValue', 0)"
    >
      清除
    </button>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContentTagFilterBar',
  props: {
    modelValue: { type: [Number, String], default: 0 },
    scope: { type: String, required: true }
  },
  emits: ['update:modelValue'],
  data() {
    return {
      loading: false,
      recommended: [],
      allTags: [],
      showAll: false
    }
  },
  computed: {
    extraCount() {
      const recIds = new Set(this.recommended.map((t) => t.tagId))
      return this.allTags.filter((t) => !recIds.has(t.tagId)).length
    },
    visibleTags() {
      if (this.showAll || !this.recommended.length) {
        return this.allTags
      }
      return this.recommended
    }
  },
  watch: {
    scope: {
      immediate: true,
      handler() {
        this.loadTags()
      }
    }
  },
  methods: {
    chipStyle(tag) {
      if (!tag?.color) return {}
      if (Number(this.modelValue) === Number(tag.tagId)) {
        return { background: tag.color, borderColor: tag.color, color: '#fff' }
      }
      return { borderColor: tag.color, color: tag.color }
    },
    toggle(tagId) {
      const next = Number(this.modelValue) === Number(tagId) ? 0 : Number(tagId)
      this.$emit('update:modelValue', next)
    },
    async loadTags() {
      if (!this.scope) return
      this.loading = true
      try {
        const [recRes, allRes] = await Promise.all([
          axios.post('/api/v1/content/tag/list', { scope: this.scope, recommendedOnly: 1 }),
          axios.post('/api/v1/content/tag/list', { scope: this.scope, recommendedOnly: 0 })
        ])
        this.recommended = recRes.data?.code === 200 ? (recRes.data.data?.tags || []) : []
        this.allTags = allRes.data?.code === 200 ? (allRes.data.data?.tags || []) : []
        if (!this.recommended.length) {
          this.showAll = true
        }
      } catch {
        this.recommended = []
        this.allTags = []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped>
.content-tag-filter {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 16px;
}

.filter-label {
  font-size: 13px;
  color: #606266;
  margin-right: 4px;
}

.tag-chip {
  border: 1px solid #dcdfe6;
  background: #fff;
  color: #606266;
  border-radius: 999px;
  padding: 4px 12px;
  font-size: 13px;
  cursor: pointer;
  line-height: 1.4;
}

.tag-chip:hover {
  border-color: #409eff;
  color: #409eff;
}

.tag-chip.active {
  background: #409eff;
  border-color: #409eff;
  color: #fff;
}

.tag-chip.more {
  border-style: dashed;
}

.tag-chip.clear {
  color: #f56c6c;
  border-color: #f56c6c;
}
</style>
